import {_, React, Component, className, lib} from '@henrybuilt/react-app'; //eslint-disable-line
import {connect, Page} from '@henrybuilt/react-app/src';
import Filters from './filters/filters.js';
import Moment from 'moment';
import {Link} from 'react-router-dom';
import './transactions-index-page.scss';

class TransactionsIndexPage extends Page {
  key = 'transactions-index';
  authGroup = 'employee';
  state = {
    filters: {},
    showAll: false,
    pageNumber: 0,
    pageSize: 15,
    hasMoreData: true,
    isLoadingMore: false,
    autoLoadCount: 0,
    maxAutoLoads: 5,
    searchTerm: '',
    isSearchMode: false,
    isSearching: false,
    searchRequestId: 0
  };

  constructor(props) {
    super(props);

    this.tableContainerRef = React.createRef();
    this.debouncedSearch = _.debounce(this.performSearch, 300);
  }

  async componentDidMount() {
    var users = await lib.api.get('users', {where: {level: [2, 3]}});
    
    this.setState({users}, () => {
      this.requestTransactions();
    });

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  requestTransactions = async () => {
    var {filters, showAll, pageSize} = this.state;

    try {
      var response = await lib.api.request({
        uri: 'transactions/filtered',
        body: {
          filters: _.omit(filters, ['searchTerm']),
          showAll,
          page: {number: 1, count: pageSize}
        }
      });

      var transactions = response.data.transactions;

      this.setState({
        transactions,
        pageNumber: 0,
        hasMoreData: transactions.length === pageSize,
        autoLoadCount: 0
      }, () => this.checkIfNeedsMoreData());
    } catch (error) {
      console.error('Error loading transactions:', error);
      this.setState({
        transactions: [],
        pageNumber: 0,
        hasMoreData: false,
        autoLoadCount: 0
      });
    }
  }

  loadMoreTransactions = async (isAutoLoad = false) => {
    var {isLoadingMore, hasMoreData, filters, showAll, pageNumber, pageSize, transactions, isSearchMode, searchTerm, isSearching} = this.state;

    if (isLoadingMore || !hasMoreData || isSearching) return;

    this.setState({isLoadingMore: true});

    try {
      var newTransactions;

      if (isSearchMode && searchTerm) {
        var response = await lib.api.request({
          uri: 'transactions/search',
          body: {
            searchTerm,
            showAll,
            filters: _.omit(filters, ['searchTerm']),
            page: {number: pageNumber + 2, count: pageSize}
          }
        });
        newTransactions = response.data.transactions;
      } else {
        var response = await lib.api.request({
          uri: 'transactions/filtered',
          body: {
            filters: _.omit(filters, ['searchTerm']),
            showAll,
            page: {number: pageNumber + 2, count: pageSize}
          }
        });
        newTransactions = response.data.transactions;
      }

      this.setState({
        transactions: [...transactions, ...newTransactions],
        pageNumber: pageNumber + 1,
        hasMoreData: newTransactions.length === pageSize,
        isLoadingMore: false
      }, () => {
        if (isAutoLoad) this.checkIfNeedsMoreData();
      });
    } catch (error) {
      console.error('Error loading more transactions:', error);
      this.setState({isLoadingMore: false});
    }
  }

  checkIfNeedsMoreData = () => {
    const {hasMoreData, isLoadingMore, autoLoadCount, maxAutoLoads} = this.state;

    if (autoLoadCount >= maxAutoLoads || !hasMoreData || isLoadingMore) {
      return;
    }

    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const hasScrollbar = documentHeight > windowHeight;

    // Load more if no scrollbar and we have more data available
    if (!hasScrollbar) {
      this.setState({autoLoadCount: autoLoadCount + 1}, () => {
        this.loadMoreTransactions(true);
      });
    }
  }

  handleScroll = (event) => {
    const {hasMoreData, isLoadingMore} = this.state;
    const scrollThreshold = 100;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = documentHeight - scrollTop - windowHeight;

    // Load more when user is near bottom of page
    if (distanceFromBottom < scrollThreshold && hasMoreData && !isLoadingMore) {
      this.loadMoreTransactions();
    }
  }

  handleFiltersChange = ({filters, showAll}) => {
    var {isSearchMode, searchTerm} = this.state;

    this.setState({filters, showAll}, () => {
      if (isSearchMode && searchTerm) {
        this.setState({
          isSearching: true,
          transactions: [],
          pageNumber: 0,
          hasMoreData: true,
          autoLoadCount: 0
        });
        this.performSearch(searchTerm);
      } else {
        this.requestTransactions();
      }
    });
  }

  handleSearchChange = ({searchTerm}) => {
    if (!searchTerm || searchTerm.trim() === '') {
      this.exitSearchMode();
      return;
    }

    this.setState({
      searchTerm,
      isSearchMode: true,
      isSearching: true,
      transactions: [],
      hasMoreData: true
    });

    this.debouncedSearch(searchTerm);
  }

  performSearch = async (searchTerm) => {
    var currentRequestId = this.state.searchRequestId + 1;
    this.setState({searchRequestId: currentRequestId});

    var {filters, pageSize, showAll} = this.state;

    try {
      var response = await lib.api.request({
        uri: 'transactions/search',
        body: {
          searchTerm,
          showAll,
          filters: _.omit(filters, ['searchTerm']),
          page: {number: 1, count: pageSize}
        }
      });

      var transactions = response.data.transactions;

      if (this.state.searchRequestId !== currentRequestId) return;

      this.setState({
        transactions,
        pageNumber: 0,
        hasMoreData: transactions.length === pageSize,
        isSearching: false,
        autoLoadCount: 0
      }, () => this.checkIfNeedsMoreData());

    } catch (error) {
      console.error('Search error:', error);
      if (this.state.searchRequestId === currentRequestId) {
        this.setState({isSearching: false});
      }
    }
  }

  exitSearchMode = () => {
    this.debouncedSearch.cancel();

    this.setState({
      searchTerm: '',
      isSearchMode: false,
      isSearching: false,
      transactions: [],
      pageNumber: 0,
      hasMoreData: true,
      autoLoadCount: 0
    }, () => this.requestTransactions());
  }

  createTransaction = async () => {
    var title = prompt('Transaction title:');

    if (title) {
      var props = {title};

      if (_.get(this, 'props.session.user.id')) props.payeeUserId = _.get(this, 'props.session.user.id');

      var transaction = await lib.api.create('transaction', {props});

      window.location = `${window.location.origin}/edit-transaction/${transaction.id}`;
    }
  }

  render() {
    var {transactions, users, searchTerm, filters, totalCollected, showAll, isLoadingMore, hasMoreData, isSearching, isSearchMode} = this.state;

    //  - {lib.price.dinero((totalCollected || 0)/ 100).toFormat('$0,0.00')} collected
    return super.render(
      <div className='transactions-index-page-content'>
        <div className='transactions-title'>Henrybuilt Checkout</div>
        <Filters onFiltersChange={this.handleFiltersChange} onSearchChange={this.handleSearchChange} {...{users, session: this.props.session}}/>
        <div className='button create-transaction' onClick={this.createTransaction}>+</div>
        <div className='transactions-table-container' ref={this.tableContainerRef}>
          <div className='transactions-table'>
            <div className='header-row row'>
              {/* <div className='cell'>ID</div> */}
              <div className='cell'>Project ID</div>
              <div className='cell'>Title</div>
              <div className='cell'>Brand</div>
              <div className='cell'>Status</div>
              <div className='cell'>Last Contact</div>
              <div className='cell'>Last Payment</div>
              <div className='cell'>Prepared By</div>
              <div className='cell'>Type</div>
              <div className='cell'>Amount</div>
            </div>
            {transactions && _.map(transactions, transaction => {
              var payeeName = _.get(_.find(this.state.users, {id: transaction.payeeUserId}), 'name');
              var lastPayment = _.last(_.get(transaction, 'data.payments'))

              return (
                <Link className='transaction row' to={`/edit-transaction/${transaction.id}`} key={transaction.id}>
                  {/* <div className='cell'>{transaction.id}</div> */}
                  <div className='cell'>{transaction.projectId === -1 ? '' : transaction.projectId}</div>
                  <div className='title-cell cell'>{transaction.title}</div>
                  <div className='cell'>{_.toUpper(transaction.brandKey)}</div>
                  <div className='cell'>{_.startCase(transaction.status)}</div>
                  <div className='cell'>{transaction.lastNotification && Moment.utc(transaction.lastNotification).from(Moment.utc())}</div>
                  <div className='cell'>{lastPayment && Moment.utc(lastPayment.date).from(Moment.utc())}</div>
                  <div className='cell'>{payeeName}</div>
                  <div className='cell'>{transaction.type === 'pif' ? 'PIF' : _.startCase(transaction.type)}</div>
                  <div className='cell'>{lib.price.dinero((transaction.amountInCents || 0) / 100).toFormat('$0,0.00')}</div>
                </Link>
              );
            })}
          </div>
          {isSearching && (
            <div className='loading-indicator'>Searching...</div>
          )}
          {isLoadingMore && !isSearching && (
            <div className='loading-indicator'>Loading more transactions...</div>
          )}
          {isSearchMode && !isSearching && transactions && transactions.length === 0 && (
            <div className='no-more-data'>No transactions found for "{searchTerm}"</div>
          )}
          {!hasMoreData && !isSearching && transactions && transactions.length > 0 && (
            <div className='no-more-data'>{isSearchMode ? 'All search results loaded' : 'All transactions loaded'}</div>
          )}
        </div>
        {/*<div className='page-controls'>
          <div className='last-page button'>&lt;</div>
          <div className='page-status'>1 / 10</div>
          <div className='next-page button'>&gt;</div>
        </div>*/}
      </div>
    );
  }
}

export default connect({})(TransactionsIndexPage);
